module.exports = __webpack_public_path__ + "img/temp.9c4ac623.svg";